export default "__VITE_ASSET__JJ6GSsqK__"